import { IconChevronRightSmall16, Label, Spinner } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from '../../actions/authentication';
import { useOfferBookingFormModalEnabled } from '../../hooks/offerBookingFormModal';
import { getIsAuthenticated } from '../../selectors/newbuilding';
import { TThunkDispatch } from '../../types/redux/thunk';
import { NewbuildingBrokerModalsContext } from '../NewbuildingBrokerModalsProvider';

export const OfferBookingLabelContainer: React.FC = () => {
  const isAuthenticated = useSelector(getIsAuthenticated);
  const isOfferBookingFormModalEnabled = useOfferBookingFormModalEnabled();
  const dispatch: TThunkDispatch = useDispatch();
  const { loadingPlace, startMicrofrontOpening } = React.useContext(NewbuildingBrokerModalsContext);

  const isLoading = loadingPlace === 'bookingLabel';
  const rightIcon = isLoading ? (
    <Spinner size={16} colorType="inherit" />
  ) : isOfferBookingFormModalEnabled ? (
    <IconChevronRightSmall16 color="current_color" />
  ) : undefined;

  const handleClick = React.useCallback(() => {
    if (isLoading) {
      return;
    }

    if (isAuthenticated) {
      startMicrofrontOpening('bookingLabel');

      return;
    }

    dispatch(
      requestAuthentication({
        onSuccess: () => () => startMicrofrontOpening('bookingLabel'),
      }),
    );
  }, [dispatch, isAuthenticated, isLoading, startMicrofrontOpening]);

  const handleKeyDown = React.useCallback(
    (event: React.KeyboardEvent<HTMLElement>) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        handleClick();
      }
    },
    [handleClick],
  );

  return (
    <Label
      color="accent-main-primary"
      background="accent-main-secondary"
      tabIndex={isOfferBookingFormModalEnabled ? 0 : undefined}
      role={isOfferBookingFormModalEnabled ? 'button' : undefined}
      aria-busy={isLoading}
      rightIcon={rightIcon}
      onClick={isOfferBookingFormModalEnabled ? handleClick : undefined}
      onKeyDown={isOfferBookingFormModalEnabled ? handleKeyDown : undefined}
    >
      Онлайн-бронирование
    </Label>
  );
};
